
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "id": "tab",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 20 20"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "切换共享"
        }
      ]
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "3",
        "width": "17",
        "height": "17",
        "rx": "3",
        "ry": "3",
        "style": "fill:#c7d4e8;opacity:0.4"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "y": "3",
        "width": "17",
        "height": "17",
        "rx": "3",
        "ry": "3",
        "style": "fill:#c7d4e8"
      }
    }
  ]
})
    }
  